import { Routes } from '@angular/router';
import { authGuard, canEditGuard, canEditOrIsActiveGuard } from '../shared/guards';

export const listingRoutes: Routes = [
  { path: ':id', loadComponent: () => import('./view/view.component').then(m => m.ViewComponent), canActivate: [canEditOrIsActiveGuard] },
  { path: ':id/edit', loadComponent: () => import('./listing-edit/edit.component').then(m => m.EditComponent), canActivate: [authGuard, canEditGuard] },
  { path: '', loadComponent: () => import('./listing-new/listing-new.component').then(m => m.ListingNewComponent), canActivate: [authGuard] }
];
